import React, { useState } from 'react';
import * as S from './ReportCard.style';

const ReportCard = ({ 
  report,
  onGenerate,
  onSettings,
  onCopy,
  onDelete
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleGenerate = () => {
    console.log('[REPORT_CARD]', 'Generate clicked for report:', report.id);
    onGenerate?.(report.id, report);
  };

  const handleSettings = () => {
    console.log('[REPORT_CARD]', 'Settings clicked for report:', report.id);
    onSettings?.(report.id, report);
  };

  const handleCopy = () => {
    console.log('[REPORT_CARD]', 'Copy clicked for report:', report.id);
    onCopy?.(report.id, report);
  };

  const handleDelete = () => {
    console.log('[REPORT_CARD]', 'Delete clicked for report:', report.id);
    onDelete?.(report.id, report);
  };

  return (
    <S.ReportCardContainer isProcessing={isProcessing}>
      {/* 처리 중 오버레이 */}
      {isProcessing && (
        <S.ProcessingOverlay>
          <S.ProcessingSpinner />
          <S.ProcessingText>처리 중...</S.ProcessingText>
        </S.ProcessingOverlay>
      )}

      <S.ReportHeader>
        <S.ReportTitle title={report.name}>{report.name}</S.ReportTitle>
      </S.ReportHeader>
      
      <S.ReportInfo>
        <S.ReportDescription title={report.description}>
          {report.description}
        </S.ReportDescription>
        <S.ReportMetadata>
          {report.sheetsCount && (
            <S.SheetsCount>시트 수: {report.sheetsCount}개</S.SheetsCount>
          )}
          {report.updatedAt && (
            <S.UpdateDate>수정: {formatDate(report.updatedAt)}</S.UpdateDate>
          )}
        </S.ReportMetadata>
      </S.ReportInfo>

      {/* <S.ReportActions>
        <S.ActionIcon 
          type="copy" 
          onClick={handleCopy}
          disabled={isProcessing}
          title="보고서 복사"
        />
        <S.ActionIcon 
          type="delete" 
          onClick={handleDelete}
          disabled={isProcessing}
          title="보고서 삭제"
        />
      </S.ReportActions> */}

      <S.ButtonGroup>
        <S.ActionButton 
          variant="primary" 
          onClick={handleGenerate}
          disabled={isProcessing}
        >
          보고서 생성
        </S.ActionButton>
        {/* <S.ActionButton 
          variant="secondary" 
          onClick={handleSettings}
          disabled={isProcessing}
        >
          설정하기
        </S.ActionButton> */}
      </S.ButtonGroup>
    </S.ReportCardContainer>
  );
};

export default ReportCard;